import { render, staticRenderFns } from "./chatList.vue?vue&type=template&id=00f7bb82&scoped=true&"
import script from "./chatList.vue?vue&type=script&lang=ts&"
export * from "./chatList.vue?vue&type=script&lang=ts&"
import style0 from "./chatList.vue?vue&type=style&index=0&id=00f7bb82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f7bb82",
  null
  
)

export default component.exports